import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApCookieConsentService } from '@ap/cookie-consent';

import { ApAdobeTargetService } from './adobe-target.service';

@NgModule({
    imports: [CommonModule],
    providers: [ApAdobeTargetService, ApCookieConsentService]
})
export class ApAdobeTargetModule {}
